import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=015b7f0a&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=015b7f0a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports